import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubComponentModule } from '../../../core/controller/modules/sub-component.module';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseViewElement } from '../base-view-element';
import { PropertySet } from '../../../core/model/helper-models/property-set.model';
import { Property } from '../../../core/model/helper-models/property.model';

@Component({
  selector: 'app-prtlrbt-z',
  templateUrl: './prtlrbt-z.component.html',
    styleUrls: ['./prtlrbt-z.component.scss',
        './../card.scss'],
    standalone: false
})
export class PrtlrbtZComponent  extends BaseViewElement implements OnChanges
{

    @Input() Maintenance: PropertySet;

    Distance: Property<any>;
    Positioning: Property<any>;

    constructor()
    {
        super('prtlrbt-z');
    }


    onResize(result: any)
    {
        this.childResizeEvent.emit();
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Maintenance == null) return;
        this.Distance = this.Maintenance.properties.get('Z_AXIS_DISTANCE');
        this.Positioning = this.Maintenance.properties.get('Z_AXIS_SWITCHING_CYCLE');
    }

}

